import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export interface ApiResult<T> {
  result: T,
  applied_fields: { [x: string]: string[] }
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  protected readonly http: HttpClient = inject(HttpClient);
  protected readonly apiUrl: string = environment.apiUrl;

  constructor() {}

  protected convertObjectToQueryString( object: {[x: string]: any} = {}) {
    return Object.keys(object).reduce((str, key, i) => {
      const delimiter = i === 0 ? '?' : '&';
      if (Array.isArray(object[key])) {
        const keyAndVal = object[key]
          .map( (v: any, i: number) => `${i === 0 ? delimiter : '&'}${key}[]=${encodeURIComponent(v)}`)
          .join('');
        return [str, keyAndVal].join('');
      }
      if (typeof object[key] === 'object' && object[key] !== null) {
        const keyAndVal = Object.keys(object[key])
          .map( (k, i) => `${i === 0 ? delimiter : '&'}${key}[${k}]=${encodeURIComponent(object[key][k])}`)
          .join('');
        return [str, keyAndVal].join('');
      }
      const val = encodeURIComponent(object[key]);
      return [str, delimiter, key, '=', val].join('');
    }, '');
  }
}
